import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

export type SpinnerSize = 'compact' | 'medium' | 'full';

@Component({
  selector: 'app-spinner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './spinner.component.html',
  styleUrl: './spinner.component.css'
})
export class SpinnerComponent {
  /**
   * Spinner size variant:
   * - 'compact': Small loading dots only (for buttons, inline)
   * - 'medium': Orbital rings + loading dots (for cards, modals)
   * - 'full': Full spinner with logo + text (for fullscreen overlays)
   */
  @Input() size: SpinnerSize = 'medium';

  /**
   * Show as fullscreen overlay with backdrop
   */
  @Input() overlay = false;

  /**
   * Show logo (only for 'full' size, auto-enabled)
   */
  @Input() showLogo = true;

  /**
   * Show app name text below logo (only for 'full' size)
   */
  @Input() showAppName = true;

  /**
   * Show background gradient effects
   */
  @Input() showBackground = true;

  /**
   * Show floating particles (only for 'full' and 'medium' with overlay)
   */
  @Input() showParticles = true;
}
